import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59ec15f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-queue-modal-employees" }

import { computed, onMounted, PropType, ref } from "vue";
import { EditQueueModalChooseUsers } from "./";
import { EditQueueAdapterService } from "../../adapter-service";
import { QueueTasksModel } from "@/components/sidebar/models";
import { EmployeeAccessModel, EmployeeModel } from "../../models";
import { EmployeeQueueAccessEnum } from "../../enums";
import { TaskParametersLeave } from "@/components/task-parameters-form/components";
import UpdateQueueTaskEmployeeRoleAccessListUserItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/UpdateQueueTaskEmployeeRoleAccessListUserItem";
import { mapUpdateUsersAccessResponse } from "../../adapter-service/adapter-service.mappers";

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-queue-modal-employees',
  props: {
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
},
  emits: ["onClose"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const apiService = new EditQueueAdapterService();

/**Параметры */


/**Все сотрудники */
const allUsers = ref<EmployeeModel[]>([]);
/**Все сотрудники с доступом к очереди */
const queueUsers = ref<EmployeeModel[]>([]);
const queueAccessUsers = ref<EmployeeAccessModel[]>([]);
const queueDeletedUsers = ref<EmployeeModel[]>([]);

/**События */

/**После рендера */
onMounted(async () => {
  await getqueueUsers();
  await getEmployees();
  await getqueueAccessUsers();
  await getDeletedAccessUsers();
});

/**Получение сотрудников */
const getqueueUsers = async () => {
  const response = await apiService.getQueueTaskEmployeeList(props.queue.Id);
  if (response.IsSuccess) {
    queueUsers.value = response.Value;
  }
};
/**Получение сотрудников */
const getqueueAccessUsers = async () => {
  const response = await apiService.getUsersWorkSpaceAsync({ QueueTaskId: props.queue.Id });
  if (response.IsSuccess) {
    queueAccessUsers.value = response.Value;
  }
};
/**Получение сотрудников */
const getDeletedAccessUsers = async () => {
  const response = await apiService.getDeletedUsersWorkSpaceAsync({ QueueTaskId: props.queue.Id });
  if (response.IsSuccess) {
    queueDeletedUsers.value = response.Value;
  }
};
/**Получить пользователей */
const getEmployees = async () => {
  const response = await apiService.getUsers();
  if (response.IsSuccess) {
    allUsers.value = response.Value;
  }
};

/**Обновить список пользователей с доступом к очереди */
const updateUsers = async () => {
  const queueUsersIds = queueUsers.value.map((x) => x.Id);
  apiService.updateQueueTaskEmployeeRoleList(props.queue.Id, queueUsersIds);
};
/**Обновить доступы к очереди */
const updateAccesses = async () => {
  await apiService.updateQueueTaskEmployeeRoleAccessList(props.queue.Id, queueUsers.value);
};
const $taskParametersLeave1 = ref<InstanceType<typeof TaskParametersLeave>>();
// const access= queueUsers
/**Открыть окно с подтверждением выхода из настройки */
const openLeaveConfirmation = (callback?: Function) => {
  $taskParametersLeave1.value?.toggle(true, callback);
};

/**данные поменялись */
const haveChanges = ref(false);

function onChange(value: boolean = true) {
  haveChanges.value = value;
}
async function saveUsersAccess() {
  const req = new UpdateQueueTaskEmployeeRoleAccessListUserItem();
  await apiService.saveUsersAcessAsync({
    QueueTaskId: props.queue.Id,
    Users: mapUpdateUsersAccessResponse(queueAccessUsers.value),
  });
  haveChanges.value = false;
}
function onClose() {
  emit("onClose");
}
/**Код для использования по ref */
__expose({
  haveChanges,
  openLeaveConfirmation,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(EditQueueModalChooseUsers), {
        title: "Все сотрудники",
        allUsers: allUsers.value,
        queue: __props.queue,
        queueUsers: queueAccessUsers.value,
        queueDeletedUsers: queueDeletedUsers.value,
        onOnChange: onChange,
        onOnClose: onClose,
        onOnSave: saveUsersAccess
      }, null, 8, ["allUsers", "queue", "queueUsers", "queueDeletedUsers"])
    ]),
    _createVNode(_unref(TaskParametersLeave), {
      ref_key: "$taskParametersLeave1",
      ref: $taskParametersLeave1
    }, null, 512)
  ], 64))
}
}

})